import request from '../../../api/request';
import { SurveyResultsListQuery } from './parts/SurveyResultsTableLoader';
import { FormDataResponseType, SurveyResponseType } from './types';

/**
 * SURVEYS SECTION
 */
const SURVEYS = {
  FORM_DATA: () =>
    `maintainers-portal/management-tools/survey-results/form-data`,
  LIST: () => `maintainers-portal/management-tools/survey-results`,
  GET: (id: string) =>
    `maintainers-portal/management-tools/survey-results/${id}/report`,
  GET_REPORT: 'maintainers-portal/management-tools/survey-results/report',
};

export async function getFormData() {
  return request<FormDataResponseType>(SURVEYS.FORM_DATA(), {
    method: 'GET',
  });
}

export async function getSurveys(params: SurveyResultsListQuery) {
  return request<SurveyResponseType>(SURVEYS.LIST(), {
    method: 'GET',
    params,
  });
}

export async function getTemplate(formData: { surveyId: number | string }) {
  return request<any>(SURVEYS.GET_REPORT, {
    data: formData,
    method: 'POST',
    responseType: 'blob',
  });
}
